import { useEffect, useState } from "react";
import { captureException } from '@sentry/nextjs';
import APIService from "@/util/api-service";
import type { User } from "./useUser";
import { Will, WillTypes } from "@/types";

const useWills = ( user: User|null, type: WillTypes  ) => {

    const [wills, setWills] = useState<Will[]>([]);
    const [gettingWills, setGettingWills] = useState(false);

    useEffect( () => {
        if ( user && ! wills?.length ) {
            setGettingWills(true);
            APIService.postWithUidToken( `/api/product/get-all/${type.toLowerCase()}`, {} ) 
            .then( ( will ) => {
                setWills( will.data );
                setGettingWills(false);
            })
            .catch( ( error ) => {
                captureException(error)
                setWills([]);
            })
        }
    }, [user]);

    return { wills, setWills, gettingWills }
}

export default useWills;